import React, {useState} from 'react';

//charts
import ChartIE from '../Components/Charts/ChartIE';
import ChartFA from '../Components/Charts/ChartFA';
import { Tabs } from 'react-bootstrap';
import { Tab } from 'bootstrap';

export default function DirectionPage(props)
{
    const [key, setKey] = useState('patients');

    return(
        <section className="h100">
            <Tabs
                id="ChartsTabs"
                activeKey={key}
                onSelect={(k) => setKey(k)}>
                <Tab eventKey="patients" title="Pacientes">
                    <ChartIE hospital={props.hospital}/>
                </Tab>
                <Tab eventKey="accounts" title="Cuentas">
                    <ChartFA hospital={props.hospital}/>
                </Tab>
            </Tabs>
        </section>
    );
}